import { render, staticRenderFns } from "./TaskDetailTabInner.vue?vue&type=template&id=63deee75&scoped=true&"
import script from "./TaskDetailTabInner.vue?vue&type=script&lang=js&"
export * from "./TaskDetailTabInner.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailTabInner.vue?vue&type=style&index=0&id=63deee75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63deee75",
  null
  
)

export default component.exports